"use client";

import { useMemo } from "react";
import defaults from "@/locales/de.json";
import type { Labels } from "@/lib/labels/types";
import { applyLabelOverrides, type LabelOverride } from "@/lib/labels/applyLabelOverrides";
import { LabelsProvider } from "@/lib/labels/LabelsProvider";

/**
 * Labels for "de", bundled as this module's own client chunk (content-hashed, cached by the
 * browser and the CDN) instead of being serialized into every page's React payload. Only the
 * tenant's overrides travel as a prop. Rendered on the server too, so hydration sees the same
 * dictionary. One file per locale keeps each locale in its own chunk.
 */
export function LabelsProvider_de({ overrides, children }: { overrides: LabelOverride[]; children: React.ReactNode }) {
    const labels = useMemo(() => applyLabelOverrides(defaults as unknown as Labels, overrides), [overrides]);
    return (
        <LabelsProvider labels={labels} locale="de">
            {children}
        </LabelsProvider>
    );
}
